import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-visit-detail-ipm',
  templateUrl: './visit-detail-ipm.component.html',
  styleUrls: ['./visit-detail-ipm.component.scss'],
})
export class VisitDetailIpmComponent implements OnInit {
  @Input() visit;
  @Input() backUrl;
  @Output() saveFields = new EventEmitter();
  public showItemList = false;
  public ipmQuestions = [];

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.visit.ipm) {
      const ipmQuestions = this.sanitizeJSONString(this.visit?.ipm);

      this.ipmQuestions = JSON.parse(ipmQuestions);

      this.ipmQuestions = this.ipmQuestions?.filter(
        (question) => question.Question !== ''
      );
    }
  }

  showItems() {
    this.showItemList = !this.showItemList;
  }

  sanitizeJSONString(str) {
    return str
      .replace(/[\u0000-\u001F\u007F-\u009F]/g, '')
      .replace(/\\(?!["\\/bfnrtu])/g, '\\\\')
      .replace(/\//g, '\\/')
      .replace(/\n/g, '')
      .replace(/\r/g, '')
      .replace(/\t/g, '')
      .replace(/\s+/g, ' ');
  }

  openIpmQuestionnaire() {
    this.saveFields.emit();
    this.router.navigate(
      ['questionnaire', this.visit.customFormId, 'PCVisit', this.visit.id],
      {
        state: { backUrl: this.backUrl },
      }
    );
  }
}
